import { render, staticRenderFns } from "./RegisterDetailGrid.vue?vue&type=template&id=e438de16&scoped=true&"
import script from "./RegisterDetailGrid.vue?vue&type=script&lang=js&"
export * from "./RegisterDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDetailGrid.vue?vue&type=style&index=0&id=e438de16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e438de16",
  null
  
)

export default component.exports